import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { BackboneComponent } from '@components/backbone/backbone.component';
import { BreadcrumbComponent } from '@components/breadcrumb/breadcrumb.component';
import { TabViewModule } from 'primeng/tabview';
import { PdfComponent } from './pdf/pdf.component';
import { UploadComponent } from './upload/upload.component';
import { TagModule } from 'primeng/tag';
import { ShowForRolesDirective } from '@directives/show-for-roles.directive';

@Component({
  selector: 'app-no-derechohabiente',
  imports: [CommonModule, BackboneComponent, BreadcrumbComponent, TagModule, TabViewModule, ShowForRolesDirective, PdfComponent, UploadComponent],
  templateUrl: './no-derechohabiente.component.html',
  styleUrl: './no-derechohabiente.component.scss',
})
export class NoDerechohabientePage {}
